class UiVideo extends HTMLElement {
  videos: NodeListOf<HTMLVideoElement>;
  pauseBtn: HTMLElement | null;
  playBtn: HTMLElement | null;

  constructor() {
    super();
    this.videos = this.querySelectorAll("video");
    this.pauseBtn = this.querySelector(".pause");
    this.playBtn = this.querySelector(".play");
  }

  connectedCallback() {
    if (this.videos.length) {
      this.pauseBtn?.addEventListener("click", this.pause.bind(this));
      this.playBtn?.addEventListener("click", this.play.bind(this));
    }
  }

  pause(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.videos.forEach((video) => video.pause());
    this.pauseBtn?.classList.add("hide");
    this.playBtn?.classList.remove("hide");
  }

  play(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.videos.forEach((video) => video.play());
    this.pauseBtn?.classList.remove("hide");
    this.playBtn?.classList.add("hide");
  }
}

customElements.define("ui-video", UiVideo);
